import { render, staticRenderFns } from "./PWA.vue?vue&type=template&id=a4b210f0&scoped=true&"
import script from "./PWA.vue?vue&type=script&lang=js&"
export * from "./PWA.vue?vue&type=script&lang=js&"
import style0 from "./PWA.vue?vue&type=style&index=0&id=a4b210f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b210f0",
  null
  
)

export default component.exports